import $ from "jquery";
import {rates} from './instant'
import {checkSymbols} from "./helpers";
import {
    checkTxStatus,
    NON_VISIBLE,
    INFO_BACKGR,
    INFO_BACKGR_CONTENT,
    CALC_USD_TYPE,
    CALC_BTC_TYPE,
    checkMaxAmountUsd
} from "./refillAdditional";

let exchangeRates = [],
    needGetRate = false,
    needCheckProcessed = false;

const ADD_FUNDS_NO_MONEY_USD = $('#refill-no-money-usd'),
      ADD_FUNDS_NO_MONEY_BTC = $('#refill-no-money-btc'),
      BTC_IN_ADDR = $('#refill-no-money-btc-wallet'),
      ADD_FUNDS_NO_MONEY_MODAL = $('#refillNoMoney'),
      MIN_REFILL_AMOUNT = $('#min-refill-no-money-amount-error');

const calcRefillNoMoneyValues = (type = CALC_USD_TYPE, USD_INPUT_FIELD, BTC_INPUT_FIELD) => {
    let btcExchangeRate = exchangeRates['BTC']['rate'],
        btcValue,
        usdAmount,
        usdValue = USD_INPUT_FIELD.val();
    if (btcExchangeRate) {
        if (type === CALC_BTC_TYPE) {
            const btcAmount = BTC_INPUT_FIELD.val();
            btcValue = btcAmount
            usdAmount = Math.round(btcAmount / btcExchangeRate / 1.2 * 100) / 100;
            USD_INPUT_FIELD.val(usdAmount);
            usdValue = usdAmount;
        }
        if (type === CALC_USD_TYPE) {
            btcValue = (usdValue * 1.2 * btcExchangeRate).toFixed(8);
            BTC_INPUT_FIELD.val(btcValue);
        }
    }

    return {
        'usd': usdValue,
        'btc': btcValue,
    }
}

const checkRefillData = () => {
    clearRefillError();
    if (ADD_FUNDS_NO_MONEY_USD.val() < 50) {
        MIN_REFILL_AMOUNT.removeClass(NON_VISIBLE);
    }
}

const clearRefillError = () => {
    if (!MIN_REFILL_AMOUNT.hasClass(NON_VISIBLE)) {
        MIN_REFILL_AMOUNT.addClass(NON_VISIBLE);
    }
}

const fillRefillNoMoneyData = (type = CALC_USD_TYPE) => {
    const calcData = calcRefillNoMoneyValues(type, ADD_FUNDS_NO_MONEY_USD, ADD_FUNDS_NO_MONEY_BTC);
    noMoneySetAdditionalData(calcData['usd'], calcData['btc']);
    checkRefillData()
}

const processingAddFunds = (modalType) => {
    rate(modalType);
    needCheckProcessed = true;
}

const refillNoMoneyModalShow = () => {
    ADD_FUNDS_NO_MONEY_MODAL.on('show.bs.modal', function (e) {
        needGetRate = true
        processingAddFunds()
    })
}

const noMoneySetAdditionalData = (usdAmount, btcValueData) => {
    const depositValue = Math.round(usdAmount * 1.2 * 100) / 100;
    $('#refill-no-money-deposit').text(depositValue)
    $('#refill-no-money-loan-amount').text(usdAmount)
    $('#refill-no-money-top-up-amount').text(btcValueData)
}

const refillNoMoneyModalHidden = () => {
    ADD_FUNDS_NO_MONEY_MODAL.on('hidden.bs.modal', function (e) {
        $('#refillNoMoneyQrCodeBlock').addClass(NON_VISIBLE);
        needGetRate = false;
        needCheckProcessed = false;
    })
}

const rate = () => {
    exchangeRates = rates;
    fillRefillNoMoneyData();
}

const updateRefillNoMoneyData = (type) => {
    checkSymbols('refill-no-money-btc');
    checkSymbols('refill-no-money-usd');
    checkMaxAmountUsd('refill-no-money-usd');
    fillRefillNoMoneyData(type);
}

const checkProcessedStatus = () => {
    const waitPaymentLabel = $('#refill-no-money-wait-payment');
    const confirmationBlock = $('#refill-no-money-confirmation-block');
    const txOnline = $('#refill-no-money-transaction-online')
    const txConfirmations = $('#refill-no-money-confirmation-count')
    const btcInAddrValue = BTC_IN_ADDR.val();
    const modalSelector = 'refillNoMoney';
    checkTxStatus(waitPaymentLabel, confirmationBlock, txOnline, txConfirmations, btcInAddrValue, modalSelector);
}

const activeFieldStyle = () => {
    ADD_FUNDS_NO_MONEY_USD.focusin(function () {
        $('#refill-no-money-prepend-usd').addClass(INFO_BACKGR);
        $('#refill-no-money-prepend-usd-text').addClass(INFO_BACKGR_CONTENT);
    });
    ADD_FUNDS_NO_MONEY_USD.focusout(function () {
        $('#refill-no-money-prepend-usd').removeClass(INFO_BACKGR);
        $('#refill-no-money-prepend-usd-text').removeClass(INFO_BACKGR_CONTENT);
    });
    ADD_FUNDS_NO_MONEY_BTC.focusin(function () {
        $('#refill-no-money-prepend-btc').addClass(INFO_BACKGR);
        $('#refill-no-money-prepend-btc-text').addClass(INFO_BACKGR_CONTENT);
    });
    ADD_FUNDS_NO_MONEY_BTC.focusout(function () {
        $('#refill-no-money-prepend-btc').removeClass(INFO_BACKGR);
        $('#refill-no-money-prepend-btc-text').removeClass(INFO_BACKGR_CONTENT);
    });
}

export const refillNoMoneyModalDisplay = (loanAmount, depositAmount) => {
    ADD_FUNDS_NO_MONEY_USD.val(loanAmount)
    $('#refill-no-money-deposit').text(depositAmount)
    $(ADD_FUNDS_NO_MONEY_MODAL).modal('show')
    fillRefillNoMoneyData()
}

$(document).ready(() => {
    activeFieldStyle();
    refillNoMoneyModalShow();
    refillNoMoneyModalHidden();
    setInterval(function () {
        if (needGetRate) {
            rate();
        }
    }, 60 * 1000);
    setInterval(function () {
        if (needCheckProcessed && BTC_IN_ADDR) {
            checkProcessedStatus();
        }
    }, 60 * 1000);
});

window.updateRefillNoMoneyData = updateRefillNoMoneyData;
